import { z } from 'zod';
import { getContactFormSchema } from '@/components/Forms/ContactForm/validation';
import { MARKETING_OPT_OUT_FIELD_ID } from '../../../../netlify/edge-functions/lead-cookies-geolocation';

export const loginContactFormSchema = getContactFormSchema()
  .pick({
    first_name: true,
    last_name: true,
    company: true,
    email: true,
    country: true,
    form_type: true,
    request_type: true,
    [MARKETING_OPT_OUT_FIELD_ID]: true,
  })
  .extend({
    scope: z.literal('login_sqcloud_enterprise'),
  });
